import axios from 'axios';

const TOKEN_STORAGE_KEY = 'aws_access_token';

const apiBaseUrl = import.meta.env.VITE_API_BASE_URL ?? '';

const axiosInstance = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_STORAGE_KEY);
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem(TOKEN_STORAGE_KEY);
      window.dispatchEvent(new CustomEvent('aws:logout'));
    }
    return Promise.reject(error);
  }
);

export const getAuthToken = () => localStorage.getItem(TOKEN_STORAGE_KEY);
export const setAuthToken = (token) => localStorage.setItem(TOKEN_STORAGE_KEY, token);
export const clearAuthToken = () => localStorage.removeItem(TOKEN_STORAGE_KEY);

export const awsClient = axiosInstance;
